// extracted by mini-css-extract-plugin
module.exports = {"actionsColumn":"OrderServiceDetails_actionsColumn__1Douh"};